import styled from "@emotion/styled"

import {
  FlexContainer,
  FlexContainerAndItem,
  FlexContainerProps,
} from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

type WaveCardContainerProps = {
  failure?: boolean
  selected: boolean
}

type StatusBorderProps = {
  statusColor: string
}

export const StatusBorder = styled.div<StatusBorderProps>`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: ${props => props.statusColor};
`

export const WaveCardContainer = styled(FlexContainer)<FlexContainerProps & WaveCardContainerProps>`
  position: relative;
  padding: 14px 16px;
  margin: 5px 8px;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  overflow: hidden;
  background-color: ${SCIENT_COLORS.darkGray4};
  border: 1px solid ${props => (props.selected ? SCIENT_COLORS.blue3 : "transparent")};

  &:hover {
    background-color: ${SCIENT_COLORS.darkGray3};
    transform: translateY(-1px);
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.15);
    border-color: ${props => (props.selected ? SCIENT_COLORS.blue1 : "transparent")};
  }
`

export const ContentContainer = styled(FlexContainer)({
  width: "100%",
  alignItems: "center",
  gap: "16px",
})

export const TickerContainer = styled(FlexContainerAndItem)({
  padding: "0 16px",
  width: "100%",
  maxHeight: "250px",
  overflow: "hidden",
  whiteSpace: "nowrap",
})
